export default __webpack_public_path__ + "static/AntIcon6-f2a9d4e9694665647ef7863b266acea5.png";